import LegalShell, { Section } from "@/components/LegalShell";

export default function Impressum() {
  return (
    <LegalShell testId="impressum-page" eyebrow="Rechtliches" title="Impressum" updated="Juli 2026">
      <Section title="Angaben gemäß § 5 DDG (Digitale-Dienste-Gesetz)">
        <p className="text-white/80">Verantwortlicher</p>
        <p>
          Sebastian Menzel<br />
          Martin-Schwantes-Straße 35<br />
          39245 Gommern<br />
          Deutschland
        </p>
        <p>
          E-Mail:{" "}
          <a href="mailto:info@festivalplan.app" className="text-[#00E5FF]">info@festivalplan.app</a>
        </p>
        <p>
          Website:{" "}
          <a href="https://festivalplan.app" className="text-[#00E5FF]">https://festivalplan.app</a>
        </p>
      </Section>

      <Section title="Über FestivalPlan">
        <p>
          FestivalPlan ist eine mobile Anwendung zur gemeinsamen Planung von Festivals und
          Veranstaltungen. Die App unterstützt Nutzer unter anderem bei:
        </p>
        <ul className="list-disc space-y-1.5 pl-5">
          <li>Planung von Festivalgruppen</li>
          <li>Organisation von Fahrgemeinschaften</li>
          <li>Verwaltung gemeinsamer Packlisten</li>
          <li>Aufgabenplanung</li>
          <li>Gruppenkasse</li>
          <li>Gruppenchat</li>
          <li>Push-Benachrichtigungen</li>
        </ul>
      </Section>

      <Section title="Kontakt">
        <p>
          Bei Fragen zur Website oder zur App erreichst du uns unter:{" "}
          <a href="mailto:support@festivalplan.app" className="text-[#00E5FF]">support@festivalplan.app</a>
        </p>
        <p>
          WhatsApp:{" "}
          <a href="https://wa.me/4915225477425" target="_blank" rel="noopener noreferrer" className="text-[#22C55E]">
            +49 1522 5477425
          </a>
        </p>
        <a
          href="https://wa.me/4915225477425"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="impressum-whatsapp-btn"
          className="mt-2 inline-flex items-center gap-2 rounded-full border border-[#22C55E]/30 bg-[#22C55E]/10 px-5 py-3 text-sm font-medium text-[#22C55E] transition-colors hover:border-[#22C55E]/60 hover:bg-[#22C55E]/20"
        >
          <svg viewBox="0 0 32 32" className="h-4 w-4" fill="currentColor" aria-hidden="true">
            <path d="M19.11 17.28c-.29-.14-1.7-.84-1.96-.93-.26-.1-.45-.14-.65.14-.19.28-.74.93-.9 1.12-.17.19-.33.21-.62.07-.29-.14-1.21-.44-2.31-1.42-.85-.76-1.43-1.7-1.6-1.98-.17-.28-.02-.44.13-.58.13-.13.29-.33.43-.5.14-.17.19-.28.29-.47.1-.19.05-.36-.02-.5-.07-.14-.65-1.57-.89-2.15-.23-.56-.47-.48-.65-.49h-.55c-.19 0-.5.07-.76.36-.26.28-1 .98-1 2.39s1.03 2.77 1.18 2.96c.14.19 2.03 3.09 4.91 4.33.69.29 1.22.47 1.63.6.68.22 1.31.19 1.8.11.55-.08 1.7-.7 1.94-1.37.24-.68.24-1.25.17-1.37-.07-.12-.26-.19-.55-.33zM16 4C9.37 4 4 9.37 4 16c0 2.11.55 4.09 1.5 5.81L4 28l6.36-1.47A11.94 11.94 0 0 0 16 28c6.63 0 12-5.37 12-12S22.63 4 16 4zm0 21.94c-1.99 0-3.86-.55-5.46-1.5l-.39-.23-3.77.87.83-3.67-.25-.4A9.94 9.94 0 0 1 6.06 16C6.06 10.51 10.51 6.06 16 6.06S25.94 10.51 25.94 16 21.49 25.94 16 25.94z" />
          </svg>
          Per WhatsApp kontaktieren
        </a>
      </Section>

      <Section title="Verantwortlich für journalistisch-redaktionelle Inhalte gemäß § 18 Abs. 2 MStV">
        <p>
          Sebastian Menzel<br />
          Martin-Schwantes-Straße 35<br />
          39245 Gommern<br />
          Deutschland
        </p>
      </Section>

      <Section title="Urheberrecht">
        <p>
          Die Inhalte dieser Website sowie der mobilen Anwendung FestivalPlan, insbesondere Texte,
          Grafiken, Logos, Designs, Softwarebestandteile und sonstige Werke, unterliegen dem deutschen
          Urheberrecht. Eine Vervielfältigung, Bearbeitung oder Verbreitung außerhalb der gesetzlichen
          Grenzen des Urheberrechts bedarf der vorherigen schriftlichen Zustimmung des jeweiligen
          Rechteinhabers.
        </p>
      </Section>

      <Section title="Marken- und Kennzeichenrechte">
        <p>
          Die Bezeichnung FestivalPlan sowie zugehörige Logos, Grafiken und Designs dienen der
          Kennzeichnung des Produkts. Die Nutzung ohne ausdrückliche Genehmigung ist nicht gestattet.
        </p>
      </Section>

      <Section title="Haftung für Inhalte">
        <p>
          Die Inhalte dieser Website wurden mit größtmöglicher Sorgfalt erstellt. Für die Richtigkeit,
          Vollständigkeit und Aktualität der bereitgestellten Inhalte übernehmen wir jedoch keine
          Gewähr.
        </p>
      </Section>

      <Section title="Haftung für externe Links">
        <p>
          Diese Website kann Links zu externen Webseiten Dritter enthalten. Für deren Inhalte sind
          ausschließlich die jeweiligen Betreiber verantwortlich. Zum Zeitpunkt der Verlinkung waren
          keine rechtswidrigen Inhalte erkennbar.
        </p>
      </Section>

      <Section title="Streitbeilegung">
        <p>
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
          <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noreferrer" className="text-[#00E5FF]">
            https://ec.europa.eu/consumers/odr/
          </a>
          . Wir sind weder verpflichtet noch bereit, an einem Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </Section>

      <Section title="Stand">
        <p>Juli 2026</p>
      </Section>
    </LegalShell>
  );
}
